import React from 'react';
import { Drawer, Empty } from 'antd';

// Stub for node/journey editing. The real edit forms are owned separately and
// will drop in here later; this keeps the interaction wired without duplicating
// in-progress work.
export default function DrawerPlaceholder({ open, title, subject, onClose }) {
  return (
    <Drawer title={title} placement="right" width={416} visible={open} onClose={onClose}>
      <p><strong>{subject}</strong></p>
      <Empty description="Editing for this node is managed elsewhere (coming soon)." />
    </Drawer>
  );
}
